import React, { useEffect, useState } from "react";
import { getUserCreditSummary, getUserTransactionSummary } from '../api/APIService';
import { get } from "lodash";

const TransactionSummary = () => {
    const today = new Date().toISOString().slice(0, 10);
    const [transactionSummary, setTransactionSummary] = useState([]);
    const [userSummary, setUserSummary] = useState([]);
    const [filterDate, setFilterDate] = useState(today);
    const [filterUsername, setFilterUsername] = useState('');
    const [userFilterUsername, setUserFilterUsername] = useState('');

    useEffect(() => {
        getUserTransactionSummary().then((response) => {
            const data = get(response, 'data', []);
            setTransactionSummary(data)
        }).catch((error) => {
            console.error("Error fetching transaction summary:", error);
        });
        getUserCreditSummary().then((response) => {
            const data = get(response, 'data', []);
            setUserSummary(data);
        }).catch((error) => {
            console.error("Error fetching user credit summary:", error);
        });


    }, []);

    // Filter logic for transactions
    const filteredTransactions = transactionSummary.filter(row => {
        const matchesDate = filterDate ? row.transactionDate === filterDate : true;
        const matchesUsername = filterUsername ? row.username?.toLowerCase().includes(filterUsername.toLowerCase()) : true;
        return matchesDate && matchesUsername;
    });

    // Filter logic for user details
    const filteredUserSummary = userSummary.filter(user =>
        userFilterUsername ? user.username?.toLowerCase().includes(userFilterUsername.toLowerCase()) : true
    );

    const totals = filteredUserSummary.reduce(
        (acc, user) => {
            acc.amount += Number(user.amount) || 0;
            acc.gift += Number(user.gift) || 0;
            acc.recharge += Number(user.recharge) || 0;
            return acc;
        },
        { amount: 0, gift: 0, recharge: 0 }
    );

    return (
        <div className="container py-5">
            <h2 className="mb-4 text-center">Transaction Summary</h2>
            <div className="table-responsive mb-5">
                <table className="table table-bordered table-striped align-middle">
                    <thead className="table-success">
                        <tr>
                            <th>
                                <div>Email<br />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={filterUsername}
                                        onChange={e => setFilterUsername(e.target.value)}
                                        placeholder="Filter"
                                    />
                                </div>
                            </th>
                            <th>
                                <div>Transaction Date<br />
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={filterDate}
                                        onChange={e => setFilterDate(e.target.value)}
                                        placeholder="Filter"
                                    />
                                </div>
                            </th>
                            <th>User Total Count</th>
                            <th>Date Wise Count</th>
                            <th>Count Per User Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredTransactions.length > 0 ? filteredTransactions.map((row, idx) => (
                            <tr key={idx}>
                                <td>{row.username}</td>
                                <td>{row.transactionDate}</td>
                                <td>{row.userTotalCount}</td>
                                <td>{row.dateWiseCount}</td>
                                <td>{row.countPerUserDate}</td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan={5} className="text-center">No records found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <h2 className="mb-4 text-center">User Details</h2>
            <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                    <thead className="table-info">
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>
                                <div>Email<br />
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={userFilterUsername}
                                        onChange={e => setUserFilterUsername(e.target.value)}
                                        placeholder="Filter"
                                    />
                                </div>
                            </th>
                            <th>Mobile</th>
                            <th>Amount</th>
                            <th>Gift</th>
                            <th>Recharge</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredUserSummary.length > 0 ? filteredUserSummary.map((user, idx) => (
                            <tr key={idx}>
                                <td>{user.id}</td>
                                <td>{user.name}</td>
                                <td>{user.username}</td>
                                <td>{user.mobile}</td>
                                <td>{user.amount}</td>
                                <td>{user.gift}</td>
                                <td>{user.recharge}</td>
                            </tr>
                        )) : (
                            <tr>
                                <td colSpan={7} className="text-center">No records found.</td>
                            </tr>
                        )}
                        {/* Total Row */}
                        {filteredUserSummary.length > 0 && (
                            <tr className="fw-bold bg-light">
                                <td colSpan={4} className="text-end">Total</td>
                                <td>{totals.amount}</td>
                                <td>{totals.gift}</td>
                                <td>{totals.recharge}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
};

export default TransactionSummary;